import { createRouter, createWebHistory } from "vue-router";
import { authorRoutes } from './author-routes';
import { hospitalRoutes } from './hospital-routes';
import { clientRoutes } from './client-routes';
import { monitoringRoutes } from './monitoring-routes';
import { workspaceRoutes } from './workspace-routes';
import { checkAuthentication } from './middleware';
import { userRoutes } from './user-routes';
import { dashboardRoutes } from './dashboard-routes';
import { groupRoutes } from './group-routes';
import { reportRoutes } from './report-routes';
import { besrRoutes } from './besr-routes';
import {controller, createAbortController} from '@/store/axios/axios';
let routes = [
  {
    path: "/",
    name: "home",
    component:  () => import(/* webpackChunkName: "author-route" */ '../views/dashboard/Dashboard'),
    beforeEnter: checkAuthentication
  },
  {
    path: "/login",
    name: "Login",
    component:  () => import(/* webpackChunkName: "author-route" */ '../views/Login'),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component:  () => import(/* webpackChunkName: "author-route" */ '../views/PageNotFound'),
  },
  {
    path: '/password/reset',
    name: 'ResetPassword',
    component:  () => import(/* webpackChunkName: "index" */ '../views/ResetPassword'),
  },
  {
    path: '/reset',
    name: 'SendToEmail',
    component:  () => import(/* webpackChunkName: "index" */ '../views/SendToEmail'),
  },
  {
    path: '/job-search',
    name: 'JobSearch',
    component:  () => import(/* webpackChunkName: "index" */ '../views/JobSearch'),
    beforeEnter: checkAuthentication

  },
  {
    path: '/editor',
    name: 'Editor',
    component:  () => import(/* webpackChunkName: "index" */ '../views/Editor'),
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component:  () => import(/* webpackChunkName: "index" */ '../views/Notifications'),
  },
  {
      path: '/search/:id',
      name: 'GeneralSearch',
      component:  () => import(/* webpackChunkName: "workspace-route" */ '../views/GeneralSearch'),
      beforeEnter: checkAuthentication,
      props: true,
  },
  {
    path: '/history',
    name: 'JobsHistory',
    component:  () => import(/* webpackChunkName: "index" */ '../views/settings/JobsHistory'),
    beforeEnter: checkAuthentication
  },
  {
    path: '/holiday',
    name: 'Holidays',
    component:  () => import(/* webpackChunkName: "index" */ '../views/settings/Holidays'),
    beforeEnter: checkAuthentication
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component:  () => import(/* webpackChunkName: "index" */ '../components/Privacy'),
    beforeEnter: checkAuthentication
  },
  {
    path: '/settings/account',
    name: 'UserSettings',
    component:  () => import(/* webpackChunkName: "index" */ '../views/settings/UserSettings'),
    beforeEnter: checkAuthentication
  },
  {
    path: '/announcement',
    name: 'Announcement',
    component:  () => import(/* webpackChunkName: "index" */ '../views/announcements/AnnouncementList'),
    beforeEnter: checkAuthentication
  },
  {
    path: '/user/announcement',
    name: 'UserAnnouncements',
    component:  () => import(/* webpackChunkName: "index" */ '../views/announcements/UserAnnouncements'),
    beforeEnter: checkAuthentication
  },
  {
    path: '/staff-monitoring',
    name: 'StaffMonitoring',
    component:  () => import(/* webpackChunkName: "index" */ '../views/dashboard/StaffMonitoring'),
    beforeEnter: checkAuthentication
  },
  {
    path: '/besr',
    name: 'BESR',
    component:  () => import(/* webpackChunkName: "index" */ '../views/besr/BESRConfiguration'),
    beforeEnter: checkAuthentication
  },
];

routes = routes.concat(authorRoutes);
routes = routes.concat(hospitalRoutes);
routes = routes.concat(clientRoutes);
routes = routes.concat(monitoringRoutes);
routes = routes.concat(workspaceRoutes);
routes = routes.concat(userRoutes);
routes = routes.concat(dashboardRoutes);
routes = routes.concat(groupRoutes);
routes = routes.concat(reportRoutes);
routes = routes.concat(besrRoutes);

const router = createRouter({
  history: createWebHistory(),
  routes,
});
/*
  beforeEach navigation guard is used so that every time routes changes previous api calls will be cancelled
  dashboard is exempted due to fetching of client list, organisation, and users. Routes with tab are exempted as it has separate controller
*/
router.beforeEach((to, from, next) => {
  if (!from.path.includes('dashboard') && !to.params.hasOwnProperty('tab')) {
    controller.abort(); // trigger abortcontroller
    createAbortController(); //create another abortcontroller for future api calls
  } 
  next();
});
export default router;
